/**
 * Lead storage service.
 * V1: persists to localStorage only (frontend-only static hosting).
 * V2 (future backend): swap the two functions below to POST to /api/leads.
 * The interface is intentionally async so nothing else has to change.
 */

const STORAGE_KEY = "boostf_leads_v1";

const readAll = () => {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
};

const writeAll = (list) => {
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
  } catch {
    /* noop */
  }
};

export async function saveLead(lead) {
  const list = readAll();
  const entry = {
    id: `lead_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`,
    createdAt: new Date().toISOString(),
    status: "reserved",
    ...lead,
  };
  list.push(entry);
  writeAll(list);
  return entry;
}

export async function updateLead(id, patch) {
  const list = readAll();
  const idx = list.findIndex((l) => l.id === id);
  if (idx >= 0) {
    list[idx] = { ...list[idx], ...patch, updatedAt: new Date().toISOString() };
    writeAll(list);
    return list[idx];
  }
  return null;
}

export async function listLeads() {
  return readAll();
}
